<template>
  <b-input-group
    :id="id"
    :append="append"
    :append-html="appendHtml"
    :prepend="prepend"
    :prepend-html="prependHtml"
    :size="size"
    :tag="tag"
  >
    <slot name="prepend" />
    <slot />
    <slot name="append" />
  </b-input-group>
</template>

<script>
import { BInputGroup } from 'bootstrap-vue';

export default {
  name: 'MInputGroup',
  components: {
    BInputGroup,
  },
  props: {
    append: {
      type: String,
      default: null,
    },
    appendHtml: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    prepend: {
      type: String,
      default: null,
    },
    prependHtml: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>
